import { useDispatch } from 'react-redux';
import { useLogger } from 'hook/error.hook';
import { wrapService } from 'actions/service_wrapper.actions';
import { putActivityEventTypeInOfferModule } from 'externals/_services/user.service';

const a_putActivityEventTypeInOfferModule = wrapService(
  putActivityEventTypeInOfferModule,
  {
    name: 'putActivityEventTypeInOfferModule',
  },
);

const useEngagementOfferModule = eventType => {
  const logger = useLogger({
    name: 'EngagementOfferModule.hook',
  });

  const dispatch = useDispatch();

  const sendPutEvenTypeFromOfferModule = () => {
    dispatch(a_putActivityEventTypeInOfferModule(eventType)).catch(err => {
      logger.reportAPIError(err);
    });
  };

  return { sendPutEvenTypeFromOfferModule };
};

export default useEngagementOfferModule;
